import logo from './logo.png';
import { useState } from 'react';
import './App.css';

// R1: Functional Components — Nav is a functional component rendered 
// by App.js onto the screen.

// R2: Passing Props — App.js passes onNavigate and currentView 
// down to Nav as props. Nav uses them to highlight the active 
// view and switch views when a menu item is clicked.
function Nav({ onNavigate, currentView }) {

    // R6: React Hooks — useState tracks whether the hamburger 
    // menu is open or closed. Clicking the hamburger toggles it.
    const [isOpen, setIsOpen] = useState(false);

    function handleNav(view) {
        onNavigate(view);
        setIsOpen(false);
    }

    return (
        <nav className="nav">
            {/* Hamburger button — left side */}
            <button
                className="hamburger"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Open menu"
            >
                {isOpen ? '✕' : '☰'}
            </button>

            {/* Centered clickable title */}
            <span className="nav-title" onClick={() => handleNav('dashboard')}>
                <img src={logo} className="nav-logo" alt="ThePinBook" />
                ThePinBook
            </span>

            {/* Empty right side to balance layout */}
            <span className="nav-spacer"></span>

            {/* Dropdown menu */}
            {isOpen && (
                <div className="nav-menu nav-menu-left">
                    <p
                        className={`nav-item ${currentView === 'dashboard' ? 'active' : ''}`}
                        onClick={() => handleNav('dashboard')}
                    >
                        Inbox
                    </p>
                    <p
                        className={`nav-item ${currentView === 'folders' ? 'active' : ''}`}
                        onClick={() => handleNav('folders')}
                    >
                        Chapters
                    </p>
                    <p
                        className={`nav-item ${currentView === 'pins' ? 'active' : ''}`}
                        onClick={() => handleNav('pins')}
                    >
                        All Pins
                    </p>
                    <p
                        className="nav-item nav-logout"
                        onClick={() => onNavigate('logout')}
                    >
                        Log out
                    </p>
                </div>
            )}
        </nav>
    );
}

export default Nav;